import React from 'react'
import dot from "../img/dot.png";
import section2 from "../img/section2.png";
import section4 from "../img/section4.png";
import Skills from './Skills';
import dot3 from '../img/dot3.png';
const About = (props) => {
  return (
    <>
                  <div id={props.about} className={`container mx-auto py-32 px-4 flex flex-col-reverse gap-16 lg:flex-row items-center justify-center`}>
  {/* Image Section */}
  <div className="relative mb-10 lg:mb-0 lg:mr-10">
    <img 
      className="h-28 absolute top-0 left-0 z-0 opacity-10" 
      src={props.darkMode ? dot3 : dot} 
      alt="Dot"
    />
    <div className="rounded-full overflow-hidden relative z-10">
      <img 
        className="h-96 md:h-96 lg:h-100 w-full object-cover" 
        src={props.darkMode ? section4 : section2}
        alt="my-image" 
      />
    </div>
  </div>

  {/* Right Text Section */}
  <div className="flex flex-col gap-7 lg:gap-5 md:gap-5 max-w-md text-center lg:text-left">
    <h1 className={`font-bold ${props.darkMode ? 'text-orange-500' : 'text-purple-800'}`}>About Me</h1>
    <h2 className={`text-3xl font-medium ${props.darkMode ? 'text-white' : 'text-black'}`}>Better Design</h2>
    <h2 className={`text-3xl font-medium ${props.darkMode ? 'text-white' : 'text-black'}`}>Better Experience</h2>
    <p className={`mb-4 ${props.darkMode ? 'text-gray-300' : 'text-gray-400'}`}>
      Designing user-friendly interfaces and developing responsive websites. I focus on clean aesthetics and seamless functionality to enhance the user experience.
    </p>

    {/* Skill Bars */}
    <Skills darkMode ={props.darkMode}/>

    
  </div>
</div>
 
    </>
  )
}

export default About
